const Group = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "groupType": 'Group Type',
    "parentGroup": "Parent Group",
    "search": "Search",

    // PAGE HEADER
    "group": "Group",

    // ERROR
    "error_name": "Enter Name",
    "error_desc": "Enter Description",
    "error_status": "Select Status",
    "error_source": "Enter Source App",
    "error_grouptype": "Select Group Type",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": "DESCRIPTION",
    "table_group_type": "GROUP TYPE",
    "table_status": "STATUS",

}

export default Group;
